import React, { useState, useEffect } from 'react';
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc
} from 'firebase/firestore';
import app from "../firebaseConfig";
import { getAuth } from 'firebase/auth';

const db = getFirestore(app);
const auth = getAuth(app);

const UserTripsManagementPage = () => {
  const [trips, setTrips] = useState([]);
  const [error, setError] = useState('');

  // Fetch current user's trips on component mount
  useEffect(() => {
    const fetchUserTrips = async () => {
      try {
        const currentUser = auth.currentUser;
        if (!currentUser) {
          setError('User not authenticated');
          return;
        }
        const tripsRef = collection(db, 'trips');
        const q = query(tripsRef, where('userId', '==', currentUser.uid));
        const querySnapshot = await getDocs(q);
        const userTrips = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setTrips(userTrips);
      } catch (err) {
        setError('Error fetching trips');
        console.error(err);
      }
    };
    fetchUserTrips();
  }, []);

  const handleCancelTrip = async (tripId) => {
    // Implement cancellation logic here
    alert(`Cancel trip ${tripId}`);
  };

  const handleRefundTrip = async (tripId) => {
    // Implement refund logic here
    alert(`Refund trip ${tripId}`);
  };

  const handleReuploadID = (tripId) => {
    // Logic to prompt user to re-upload ID
    alert(`Prompt re-upload for ID on trip ${tripId}`);
  };

  const handleReuploadInsurance = (tripId) => {
    // Logic to prompt user to re-upload Insurance
    alert(`Prompt re-upload for Insurance on trip ${tripId}`);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>My Trips</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {trips.length === 0 && <p>You have no trips.</p>}
      {trips.map(trip => (
        <div
          key={trip.id}
          style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px' }}
        >
          <p><strong>Car:</strong> {trip.carName}</p>
          <p><strong>Payment Amount:</strong> ${trip.paymentAmount}</p>
          <p><strong>Rental Days:</strong> {trip.rentalDays}</p>
          {trip.addOns && trip.addOns.includes('delivery') && (
            <p><strong>Delivery Address:</strong> {trip.deliveryAddress}</p>
          )}

          <div>
            <h4>ID and Insurance Status</h4>
            <p><strong>ID Approved:</strong> {trip.idApproved ? 'Yes' : 'No'}</p>
            {!trip.idApproved && (
              <button onClick={() => handleReuploadID(trip.id)}>
                Re-upload ID
              </button>
            )}
            <p><strong>Insurance Approved:</strong> {trip.insuranceApproved ? 'Yes' : 'No'}</p>
            {!trip.insuranceApproved && (
              <button onClick={() => handleReuploadInsurance(trip.id)}>
                Re-upload Insurance
              </button>
            )}
          </div>

          <div style={{ marginTop: '10px' }}>
            <button onClick={() => handleCancelTrip(trip.id)}>Cancel Trip</button>
            <button onClick={() => handleRefundTrip(trip.id)}>Request Refund</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserTripsManagementPage;
